import { Container, injected } from 'brandi';
import { TOKENS } from './tokens';
import {
  AppointmentService,
  AuthService,
  DoctorService,
  PatientService,
  SessionService,
  SpecialtyService,
  UserService
} from '../../domain/services';

export function bindServices(container: Container): Container {
  container.bind(TOKENS.userService).toInstance(UserService).inSingletonScope();
  injected(UserService, TOKENS.userRepository);

  container.bind(TOKENS.authService).toInstance(AuthService).inSingletonScope();
  injected(AuthService, TOKENS.authHandler, TOKENS.userService, TOKENS.doctorService);

  container.bind(TOKENS.appointmentService).toInstance(AppointmentService).inSingletonScope();
  injected(AppointmentService, TOKENS.appointmentRepository);

  container.bind(TOKENS.doctorService).toInstance(DoctorService).inSingletonScope();
  injected(DoctorService, TOKENS.doctorRepository);

  container.bind(TOKENS.patientService).toInstance(PatientService).inSingletonScope();
  injected(PatientService, TOKENS.patientRepository);

  container.bind(TOKENS.sessionService).toInstance(SessionService).inSingletonScope();

  container.bind(TOKENS.specialtyService).toInstance(SpecialtyService).inSingletonScope();
  injected(SpecialtyService, TOKENS.specialtyRepository);

  return container;
}
